import { request } from '../client'
import { InitResponse } from '@/services/models/response'

export async function getInitialData() {
  return request<InitResponse>({
    method: 'GET',
    url: '/v1/init',
  })
}
